import React from 'react'
import useLocale from '../hooks/useLocale'
import PropTypes from 'prop-types'
import { languages } from './constants'

export const withLocale = WrappedComponent => {
  const WithLocale = props => {
    const locale = useLocale()
    return <WrappedComponent locale={locale} {...props} />
  }

  WithLocale.displayName = `withLocale(${WrappedComponent.displayName})`

  return WithLocale
}

export const localeShape = PropTypes.shape({
  language: PropTypes.oneOf(languages).isRequired,
  currency: PropTypes.string.isRequired,
  country: PropTypes.string.isRequired,
  setLanguage: PropTypes.func.isRequired,
  setCurrency: PropTypes.func.isRequired,
  setCountry: PropTypes.func.isRequired,
})
